export interface LegacyCheckoutConfig {
  quoteData?: {
    quote_currency_code?: string;
  };
  payment?: {
    adyenGooglePay?: {
      checkoutEnvironment?: string;
      merchantIdentifier?: string;
      merchantAccount?: string;
    };
  };
}

export function readLegacyCheckoutConfig(): LegacyCheckoutConfig | undefined {
  const config: unknown = (window as Window & { checkoutConfig?: unknown })
    .checkoutConfig;
  return config !== null && typeof config === "object"
    ? (config as LegacyCheckoutConfig)
    : undefined;
}
